// extracted by mini-css-extract-plugin
module.exports = {"outerCircle":"mySocialIconButton_outerCircle__JUx0B","icon":"mySocialIconButton_icon__PQfcl"};